<template>
  <div>
    <div>
      <CreateIssueForm
        v-if="this.toggleCreateIssueForm == true"
        v-on:list-of-new-issues="addNewIssuesLocally($event)"
        v-on:close-create-issue-form="toggleCreateIssueFormmethod()"
        :priorityList="this.priorityList"
      /> 
      <EditIssueForm
        v-if="this.toggleEditIssueForm == true"
        :issue="this.selectedIssueToEdit"
        v-on:update-issue-locally="updateIssueLocally($event)"
        v-on:close-edit-issue-form="toggleEditIssueFormMethod()"
       :priorityList="this.priorityList"
      />
      <DeleteIssueForm
        v-if="this.toggleDeleteIssueForm == true"
        :issue="this.selectedIssueToDelete"
        v-on:delete-issue-locally="deleteIssueLocally($event)"
        v-on:close-delete-issue-form="toggleDeleteIssue()"
      />
      

    <!-- "keep alive" prevents the data from being reset when the user closes the form, 
         the idea is he should see his previously selected filters when he wants to filter again.
         if he wants to reset there's a reset button on the form. -->

      <keep-alive>
        <filteringIssues
          v-if="this.displayFiltersDialog == true"
          :users="usersLinkedToUser"
          v-on:submittedIssueFilters="closeFormAndFilterIssues($event)"
          v-on:filtersReset="resetFilters($event)"
          :key="filterComponentKey"
        />
      </keep-alive>

    </div>

    <div v-if="this.loadingIssues == true" class="loader"></div>

    <div
      class="issues"
      v-if="
        this.loadingIssues == false &&
        this.toggleCreateIssueForm == false &&
        this.toggleEditIssueForm == false &&
        this.toggleDeleteIssueForm == false &&
        this.issuelist[0] != undefined"
    >

        <!-- the conditional class is to hide the issue list on mobile devices when the user is viewing an issue,
              so everytime he clicks on an issue the issue details takes the full screen and to choose another issue 
              he can use the back button.
          -->
          
          <div class="nav"
          :class="{hide : this.screenWidth < 979 && this.$route.fullPath.includes('issue')}"
          >

            <div class="flex filter-parent">

                  <el-input
                      size="mini"
                      placeholder="Search or filter issues"
                      v-model="search"
                      style="max-width: 260px;"
                  ></el-input>

                    <a 
                        class="a-link-style left-in-flex" 
                        @click="toggleFiltersDialog()
                        "> 
                        Filters
                        <span v-if="this.filterCount != null"> {{ '(' + filterCount + ')' }} </span>
                    </a>
            </div>

              <ul style="padding:0px; margin:0px;">
                <div v-for="issue in searchIssues()" :key="issue.issueid">
                  <li  class="tst-issue-in-list" @click="selectIssueForLogViewer(issue.issueid, issue)"
                      :class="{'selected-link' : currentIssue.issueid == issue.issueid}"
                  >

                    <div class="priority-vertical-line" :style="{'border-color': setColor(issue.issuepriorityname)}"></div>

                    <i id="completed-icon" class="fas fa-check-circle"
                    v-if="issue.status == false"></i>

                    <i id="due-passed" class="fas fa-calendar-times"
                    v-if="issue.status == true && 
                    issue.overdue == true  &&
                      issue.duedate != null"
                    ></i>

                    <a class="truncate-text a"
                      :class="{'selected-link' : currentIssue.issueid == issue.issueid}"
                    >{{issue.issuetitle}}</a>

                    <el-avatar
                      v-if="issue.userassignedpicurl != null"
                      :size="30"
                      :src="issue.userassignedpicurl"
                      style="position: absolute; right: 32px;"
                    ></el-avatar>

                    <el-dropdown 
                        v-if="issue.permissions.candelete == true &&
                        issue.permissions.canedit == true"
                        class="tst-issue-options-menu" trigger="click" style="position:absolute; right: 13px;">
                      <el-button v-on:click.stop type="text">
                        <i class="el-icon-s-operation"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown" >
                        <el-dropdown-item style="padding: 0px 20px">
                          <el-button
                          type="text"
                          style="color:unset"
                          class="tst-edit-issue-option"
                            v-if="issue.permissions.canedit == true"
                            @click.native="toggleEditIssueFormMethod(issue)"
                          >
                            <i class="fa fa-edit mt-2" />Edit Work Order
                          </el-button>
                        </el-dropdown-item>
                        <el-dropdown-item style="padding: 0px 20px">
                          <el-button
                            type="text"
                            style="color:unset"
                            class="tst-delete-issue-option"
                            v-if="issue.permissions.candelete == true"
                            @click.native="toggleDeleteIssue(issue)"
                          >
                            <i class="fa fa-trash mt-2" />Delete Work Order
                          </el-button>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <!-- <el-badge v-if="issue.unreadmessagescount > 0 " :value="issue.unreadmessagescount"></el-badge> -->
                    <el-badge style="position: absolute; right: 4px;" is-dot v-if="issue.unreadmessagescount > 0" ></el-badge>

                  </li>
                  <el-divider style="margin:0px;"></el-divider>
                </div>
              </ul>

          <div style="height:74px;"></div>
        </div>

        <IssueDetailsAndLogs
            :currentIssue.sync="currentIssue"
            :issueheaders="this.issueheaders"
            :propertyid="this.currentpropertyid"
            :key="issueDetailsAndLogsKey"
            :priorityList="this.priorityList"

          >
            
          </IssueDetailsAndLogs>
     </div>

    <!-- this div handles if there's no issues for this asset yet -->
    
     <div v-if="this.issuelist[0] == undefined 
                  && this.loadingIssues == false 
                  && this.toggleCreateIssueForm == false
                  && this.issuesFiltered == false
                  "
     >

     <h1> There's no Work Orders related to you </h1>
      <h2 v-if="this.issueheaders.cancreateissuesomewhere == true"> Please click on the button to add a Work Order. </h2>
      <h2 v-else> Please ask the manager to add a Work Order. </h2>
   
   </div>

    <!-- this div handles if after he filters there's no work order matching the filters -->

    <div
      class="align-center"
      v-if="this.issuelist[0] == undefined && this.issuesFiltered == true"
    >
    <h2 id="no-issues-filter"> No Work Order match this filters. </h2>
    
        <a 
          class="a-link-style" 
          @click="toggleFiltersDialog()"> 
          Filters
            <span v-if="this.filterCount != null"> {{ '(' + filterCount + ')' }} </span>
      </a>
      
    </div>
   
       <div
         v-if=" this.toggleCreateIssueForm == false &&
                this.toggleEditIssueForm == false &&
                this.toggleDeleteIssueForm == false &&
                this.issueheaders.cancreateissuesomewhere == true &&
                (!this.$route.fullPath.includes('issue-') || this.screenWidth > 979)
                "
        >
            <fab
              class="tst-add-issue-fab" 
              @click.native="toggleCreateIssueFormmethod()"
              :style="fabPosition" 
              bg-color="#02746E"
              icon="add"
              icon-size="small"
          ></fab>
        </div>

      
  </div>
</template>

<script>

import EventService from "@/services/EventService.js";
import CreateIssueForm from "@/components/issues/CreateIssueForm.vue";
import EditIssueForm from "@/components/issues/EditIssueForm.vue";
import DeleteIssueForm from "@/components/issues/DeleteIssueForm.vue";
import { mapState } from "vuex";
import EventBus from '@/services/EventBus.js';
import moment from 'moment'
import LogRocket from 'logrocket';
import filteringIssues from "@/components/issues/filteringIssues.vue";
import IssueDetailsAndLogs from "@/components/issues/IssueDetailsAndLogs.vue"
import { mapActions } from "vuex";
import fab from "vue-fab";


export default {

  components: {
    CreateIssueForm,
    EditIssueForm,
    DeleteIssueForm,
    filteringIssues,
    IssueDetailsAndLogs,
    fab
  },

  data() {
    return {
    	
   	  
      currentpropertyid: null,
      machineid: null,
      issueheaders: {},
      issuelist: [],
      toggleCreateIssueForm: false,
      toggleEditIssueForm: false,
      toggleDeleteIssueForm: false,
      displayFiltersDialog: false,
      selectedIssueToEdit: {},
      selectedIssueToDelete: {},
      currentPropertyTimeOffset: null,
      logsofcurrentlyselectedissue: [],
      logheadersofcurrentlyselectedissue: {},
      sortMode: undefined,
      search: "",
      loadingIssues: false,
      checked: {},
      currentIssue: {},
      onSingleIssuePage: true,
      issueHasUpdated: false,
      updatedIssue: null,
      currentMaintenanceHistory: [],
      issuesFiltered: false,
      filterCount: null,
      filterComponentKey: 0,
      usersLinkedToUser: [],
      priorityList: [],
      selectedPriority: {},
      issueDetailsAndLogsKey: 123,
      filtersForIssues: { selectedUsers:   {
                              owner:    "All",
                              created:  "All",
                              assigned: "All"
                        },
                        issueStatus:   "All",
                        issuesCanComplete: false
                      }
    };
  },
  created(){
    this.newTitle("Work Orders");
  },
  mounted() {
  
      this.loadingIssues = true;

      EventService.getUserIssues(this.user.userid, "all", "all")
      .then(response => {
        this.issuelist = response.data.issueslist;
        this.issueheaders = response.data;

      })
      .then(() => {

           this.loadingIssues = false;
       
          // this gets the issue id from the url and selects the issue accordingly
            var issueIdFromUrl = this.$router.currentRoute.hash.replace("#issue-", "");

            this.issuelist.forEach((issue) => {

                  if (issueIdFromUrl == issue.issueid)
                  {
                      this.selectIssueForLogViewer(issue.issueid, issue)
                  }

            });    
        })

        // get users linked to current user to send it into the filter component to have available the users and not 
        // load it then
           EventService.getUsersLinkedToUser(this.user).then( response => {
               this.usersLinkedToUser = response.data;
           });

          // get list of possible priorities to send it into the certain components to have it available and not 
          // load it when the components renders
           EventService.getListOfIssuePriorities().then( response => {
                this.priorityList = response.data.prioritieslist;
           }) 

      //   EventBus.$on('comment-from-signalr', (log) =>   this.logsofcurrentlyselectedissue.push(log));

      // a separate event to close logs of issues on mobile, since the layout of issues and logs
      // on mobile is different, due to smaller screen size the user never sees both the issue list 
      // and the issue details, he sees first the list and when selecting he sees only the details, and can 
      // go back with a button 

        this.$root.$on("close-logs-of-issues-on-mobile", () =>{
            this.closeLogsFromBackButton()
        });

        // this is an event coming from the back button component and beign used in forms to close form 
        // when the back button is being pressed
        this.$root.$on("close-form", () => this.closeFormsFromBackButton());
        
        
        
       // this.reSaveTemplates();
        
  },
  updated(){
    //this is a workaround to navigate to the updated issue, and update the issue
    // the issue details in the note pad. the regular way to call this select function
    // in the updateIssueLocally function made errors and also the one commented out
    // here below.
     if(this.issueHasUpdated == true){
         this.selectIssueForLogViewer( this.updatedIssue.issueid, this.updatedIssue);
         }

   // this.$root.$on("update-issue-locally", () => this.selectIssueForLogViewer( this.updatedIssue.issueid, this.updatedIssue));

  },
  
  methods: {

  ...mapActions([ "newTitle"]),
  
  connectToSignalr(id, pageName){
          $.connection.hub.qs = {
                'BearerToken': this.user.access_token
          
            };
          $.connection.hub.url = "https://givemeachance.xyz/signalr";

          var chat = $.connection.messageHub;

          chat.client.sendMessage = (message) => {

            this.addLogLocally(JSON.parse(message))

            };
// in comments second parameter "issue"

            $.connection.hub.logging = true;

             if ($.connection.hub && $.connection.hub.state === $.signalR.connectionState.disconnected) {

            $.connection.hub.start({ withCredentials: false}).done(function () {
                //debugger
                console.log('Now connected, connection ID=' + $.connection.hub.id);
            }).done(  () => {
                     chat.server.connectedOnPage(id, pageName);
                }).fail(function (error) {
                       debugger
                       console.log('Invocation of NewContosoChatMessage failed. Error: ' + error);


                   });
             } else {
                chat.server.connectedOnPage(id, pageName);
             }
    },
   setColor(issuepriorityname){
       switch(issuepriorityname){
          case "Low":
              return "#edd605";
              break;
          case "Medium":
              return "#f08205";
              break;
          case "High":
              return "#de1d0b";
              break;
        }
      },
  selectIssueForLogViewer(issueid, currentIssue) {

        this.issueHasUpdated = false;

        // this.connectToSignalr(issueid, "issue")

        //push to the router the selected issue id to enable to come back to current issue on reload
      //  this.$router.push("#issue-" + issueid).catch(err => {});
         this.$router.replace("#issue-" + issueid);

        //keep javascript from changing date based on users timezone
        if(currentIssue.duedate != null){
            currentIssue.duedate = moment.parseZone(currentIssue.duedate).format("MMM DD YYYY");
        }
        this.currentIssue = currentIssue;
        this.currentpropertyid = currentIssue.propertyid;

        //this is to force the component to rerender and not stay with old data when switching issues
        this.issueDetailsAndLogsKey++;
    },
   

    closeLogsFromBackButton() {

        //this closeLogsFromBackButton() gets called if you click tab1 inside a issue but it also happens when the notes page loads
        // first on mobile and makes the route to switch to tab2, so therefore we check the route if it's on issue page
      
      if(this.$route.fullPath.includes("issue-"))
        {
          var routeWithoutHash = this.$route.path;
        
          this.$router.replace(routeWithoutHash + "#nav").catch(err => {});
        }
    },
    changBackButton() {
        this.$root.$emit("form-toggled");
    },
    closeFormsFromBackButton() {
        this.toggleCreateIssueForm = false;
        this.toggleEditIssueForm = false;
        this.toggleDeleteIssueForm = false;
    },
    searchIssues() {
        return this.sortedIssues.filter(issue =>
            issue.issuetitle.toLowerCase().includes(this.search.toLowerCase())
        );
    },
    addNewIssuesLocally($event) {
        $event.forEach(issue => {
          this.issuelist.push(issue);
        });
    },
    toggleCreateIssueFormmethod() {
        this.toggleCreateIssueForm = !this.toggleCreateIssueForm;
        this.changBackButton();
    },

    toggleEditIssueFormMethod(issue) {

        if (issue) 
        {
            this.selectedIssueToEdit = issue;
        }
      
        this.toggleEditIssueForm = !this.toggleEditIssueForm;
        this.changBackButton();
    },
    toggleDeleteIssue(issue) {

        if (issue) {
          this.selectedIssueToDelete = issue;
        }

        this.toggleDeleteIssueForm = !this.toggleDeleteIssueForm;
        this.changBackButton();
    },
    toggleFiltersDialog(){

      this.displayFiltersDialog = !this.displayFiltersDialog;

    },
    closeFormAndFilterIssues($event){
       
        this.toggleFiltersDialog();

        // the issue list gets returned in computed() filtered by 'this.filtersForIssues' and gets updated 
        // automatically by vue when 'this.filtersForIssues'
        this.filtersForIssues = $event;

        this.sortMode = $event.sortMode; 

        this.filterCount = $event.filterCount;
        
        this.issuesFiltered = true;

        if ( this.issuelist.indexOf(this.currentIssue) < 0) {
             this.currentIssue = {};       
             }
        
      },
      resetFilters(){

          // this.filterComponentKey++;

          this.filtersForIssues = { selectedUsers: {
                                      owner:    "All",
                                      created:  "All",
                                      assigned: "All"
                                },
                                  issueStatus:   "All",
                                  issuesCanComplete: false
                                }

            this.sortMode = undefined;

            this.filterCount = null;

            this.issuesFiltered = false;

    },
    updateIssueLocally($event) {

     EventService.getSingleIssue($event[0].issueid).then( response =>{

          this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Work Order Updated"
          })
        
            this.issueHasUpdated = true;
            this.$set(this.issuelist, this.issuelist.indexOf($event[0]), response.data.issuedetails);
            this.updatedIssue = response.data.issuedetails;
       })
    },
    deleteIssueLocally($event) {
        this.currentIssue = {};
        this.$delete(this.issuelist, this.issuelist.indexOf($event));
    },
    markMessagesRead(){
    this.currentIssue.unreadmessagescount = 0;
    }
  },
  computed: {

    ...mapState({
      user: state => state.user.user
    }),

    screenWidth: function() {
      return document.documentElement.clientWidth;
    },

    fabPosition : function(){
        // if on mobile
        if(this.screenWidth < 979)
        {
            return {
                    position: "fixed",
                    right: "17px",
                    left: "unset"
                  }
        }
        // if on desktop with issues 
        else if(this.issuelist.length > 0)
        {
            return {
                    position: "fixed",
                    bottom: "15px",
                    left: "257px",
                    right: "unset"
                   }
        }
        // if on desktop with no issues
        else
        {  
            return {
                    position: "fixed",
                    right: "20px",
                    bottom: "11px"
                   }
        }
    },

    sortedIssues: function() {
      function alphabetizeTitle(a, b) {
        if (a.issuetitle.toUpperCase() < b.issuetitle.toUpperCase()) return -1;
        if (a.issuetitle.toUpperCase() > b.issuetitle.toUpperCase()) return 1;
        return 0;
      }

      function alphabetizeAssignee(a, b) {
        if(a.userassignedname == null) return 1;
        if(b.userassignedname == null) return -1;

        if (a.userassignedname.toUpperCase() < b.userassignedname.toUpperCase()) return -1;
        if (a.userassignedname.toUpperCase() > b.userassignedname.toUpperCase()) return 1;
        return 0;
      }

       function alphabetizeOpenDate(a, b) {
        if (a.openeddate > b.openeddate) return -1;
        if (a.openeddate < b.openeddate) return 1;
        return 0;
      }

       function alphabetizeDueDate(a, b) {
         if(a.duedate == null) return 1;
         if(b.duedate == null) return -1;

        if (new Date(a.duedate) < new Date(b.duedate)) return -1;
        if (new Date(a.duedate) > new Date(b.duedate)) return 1;
        return 0;
      }

       function alphabetizeStatus(a, b) {
        if (a.status > b.status) return -1;
        if (a.status < b.status) return 1;
        //check between all that is true which has an earlier date and list it first, same between all false
        if (a.openeddate > b.openeddate) return -1;
        if (a.openeddate < b.openeddate) return 1;
        return 0;
      }
       
       function workPriority(a, b) {
    	   
    	    if(a.issuepriorityname == "Low"){
    	    	a.issuepriorityindex = 0;
    	    }
    	    
    	  	if(a.issuepriorityname == "Medium"){
    	  		a.issuepriorityindex = 1;
  	    	}
    	  	
	      	if(a.issuepriorityname == "High"){
	      		a.issuepriorityindex = 2;
	  	    }
	      	
	      	if(b.issuepriorityname == "Low"){
    	    	b.issuepriorityindex = 0;
    	    }
    	    
    	  	if(b.issuepriorityname == "Medium"){
    	  		b.issuepriorityindex = 1;
  	    	}
    	  	
	      	if(b.issuepriorityname == "High"){
	      		b.issuepriorityindex = 2;
	  	    }
    	  
	      	if (a.issuepriorityindex < b.issuepriorityindex) return -1;
	        if (a.issuepriorityindex > b.issuepriorityindex) return 1;
         return 0;
       }

      if (this.sortMode == "Alphabetical") {
        return this.issuelist.slice().sort(alphabetizeTitle);
      }

      if (this.sortMode == "Assignee") {
        return this.issuelist.slice().sort(alphabetizeAssignee);
      }

      if (this.sortMode == "Due Date") {
        return this.issuelist.slice().sort(alphabetizeDueDate);
      }

      
      if (this.sortMode == "Status") {
        return this.issuelist.slice().sort(alphabetizeStatus);
      }
      
      if (this.sortMode == "Priority") {
    	  return this.issuelist.slice().sort(workPriority);
      }

      return this.issuelist.slice().sort(alphabetizeOpenDate).filter( issue => 
                                        
                     // this.filtersForIssues gets set the default in data(), and when the user selects filters it updates in closeFormAndFilterIssues().
                     // the computed issue list always returns the list based on filters, so on every set of conditions it checks if it's the default of "All" then
                     // make all issues pass this set of conditions.
                         (issue.ownerid == this.filtersForIssues.selectedUsers.owner.userid || this.filtersForIssues.selectedUsers.owner == "All")
                      && (issue.useropened == this.filtersForIssues.selectedUsers.created.userid || this.filtersForIssues.selectedUsers.created == "All")
                      && (issue.userassigned == this.filtersForIssues.selectedUsers.assigned.userid ||  this.filtersForIssues.selectedUsers.assigned == "All")
                    
                     // this set of conditions will filter out issues which status is 'not true' meaning issue is closed, if the user chose to filter by "open".
                     // the way it checks is if the users filter is not "All" and not "closed" so the only thing left is "open", and issue.status is 'not true'
                     // then it won't pass this condition set and be filtered out from list.
                    
                      && (issue.status == true || this.filtersForIssues.issueStatus == "All" || this.filtersForIssues.issueStatus == "closed")
                    
                     // this is checking the same way as the earlier line (see comment), the earlier will filter out where issue.status is 'not true'
                     // when the user selected "open". here it's the opposite, it will filter out where issue status is 'true' when the user selected "closed"
                      && (issue.status == false || this.filtersForIssues.issueStatus == "All" || this.filtersForIssues.issueStatus == "open")
                    
                     // this filters out issues that are not recurring and cannot be completed if user filtered by "issues that can be completed". 
                      && (issue.cancompletealready == true || this.filtersForIssues.issuesCanComplete == false || issue.recurring == false )
                    );

    },
          
  }
};
</script>

<style scoped>
.router-container {
  margin-bottom: 0px;
}
.issues {
  display: flex;
  flex-direction: row;
  height: calc(100vh - 63px);
}
.el-divider--horizontal {
  margin: 0px;
}
.nav {
  min-width: 338px;
  max-width: 338px;
  position: relative;
  overflow: hidden;
  overflow-y: scroll;
  font-size: 21px;
}
.priority-vertical-line{
  display: inline-block;
  border-left: 6px solid;
  height: 33px;
}
.filter-parent{
 margin: 14px 0px;
}


a {
  padding: 6px 8px 6px 12px;
  text-decoration: none;
  font-size: 14px;
  color:  rgb(89, 89, 89);;
  display: inline-block;
  cursor: pointer;
}

li {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px 0px;
}

li:hover a {
  background-color: #129e92;
  color: white;
}

li:hover {
  cursor: pointer;
  background-color: #129e92;
  color: white;
}

a:hover {
  cursor: pointer;
  background-color: #129e92;
  color: white;
}


.selected-link {
  background-color: hsl(160, 53%, 74%);
}

.a-link-style{
  text-decoration: underline;
  color: #02746E;;
}
.a-link-style:hover{
background-color: unset;
color: unset;
}
.li-maintenance:hover{
  background-color: unset;
color: unset;
}

.align-right{
  text-align: right;
}

 h4{
   display: inline-block;
      max-width: 180px;
      min-width: 180px;
      margin-left: 55px;
      }
    hr {
      height:0; 
      border:0; 
      border-top: 0.5px solid #083972;
    }
    .done-button{
      text-align: right;
       max-width: 200px;
      min-width: 200px;
    }

.hide {
  display: none;
}


.a{
    max-width: 57%;
    left: 32px;
    position: relative;
}

h1{
  text-align: center;
}

h2{
  text-align: center;
}

h3{
  text-align: center;
}

#completed-icon{
    color: hsl(150, 100%, 43%);
    margin-left: 10px; 
    position: absolute;
}

#due-passed{
   margin-left: 10px; 
   position: absolute;
   color: #F85E5E;
}

.flex{
  display: flex;
}

.left-in-flex{
   margin-left: auto;
}

.align-center{
  text-align: center;
}

#no-issues-filter{
   display: inline-block;
}


@media (min-width: 250px) and (max-width: 979px) {
  .maintenance-parent{
    min-width: 100%;
    max-width: 100%;
  }
  .p-maintenance{
    display: block;
  }
  h4{
    display: block;

  }
  .align-right{
    text-align: left;
  }
  .issues{
      height: calc(100vh - 65px);
  }
  .nav {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }

  .note-pad {
    width: 100%;
    left: unset;
    margin: 1px;
  }

  .log-parent {
    width: 95vw;
  }

  .note {
    width: 85%;
  }

  .title{
    text-align: left;
  }
  .p-inner {
    position: unset;
  }

.description{
  vertical-align: text-top;
}

}
@media (min-width: 250px) and (max-width: 600px) {
  .p-header{
    margin: 8px 12px;
  }
.p-inner{
  max-width: 100%;
  margin: 12px 6px;
}
.description{
    display: block;
    max-width: 85%;
    margin: 15px auto;
    width: fit-content;
}
.open-date{
      margin: unset;
}
}
</style>
